import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-eotpremnica',
    templateUrl:'./eotpremnice.component.html'
})
export class EOtpremnicaComponent implements OnInit {

    constructor(){}

    ngOnInit(){
        
    }
}